module.exports = __webpack_public_path__ + "img/claireabella.3bc75093.webp";